import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';



import './common/css/font-awesome.min.css';

import Adminprofile from './components/Account/Adminprofile';
import Login from './components/Account/Login';
import Logout from "./components/Account/Logout";
import Setting from "./components/Account/Setting";
import Changepassword from "./components/Account/Changepassword";
import Forgetpassword from "./components/Account/Forgetpassword";
import Resetpassword from "./components/Account/Resetpassword";


import UserList from "./components/User/List";
import UserEdit from "./components/User/Edit";
import UserAdd from "./components/User/Add";
import UserView from "./components/User/View";

import ContractorList from "./components/Contractor/List";
import ContractorEdit from "./components/Contractor/Edit";
import ContractorAdd from "./components/Contractor/Add";
import ContractorView from "./components/Contractor/View";

import SubcontractorList from "./components/Subcontractor/List";
import SubcontractorEdit from "./components/Subcontractor/Edit";
import SubcontractorAdd from "./components/Subcontractor/Add";
import SubcontractorView from "./components/Subcontractor/View";

import ProjectList from "./components/Project/List";
import ProjectView from "./components/Project/View";

import JobList from "./components/Job/List";
import JobView from "./components/Job/View";

import CompaniesList from "./components/Companies/List";
import CompaniesEdit from "./components/Companies/Edit";
import CompaniesAdd from "./components/Companies/Add";
import CompaniesView from "./components/Companies/View";


import Fontlist from "./components/Fonts/List";
import FontAdd from "./components/Fonts/Add";
import FontEdit from "./components/Fonts/Edit";

import TemplateList from './components/Templates/List';
import TemplateAdd from './components/Templates/Add';
import TemplateEdit from './components/Templates/Edit';

import DashboardList from "./components/Dashboard/List";
import Gallery from "./components/Gallery/Gallery";

import FaqCategoryList from "./components/FaqCategory/List";
import FaqCategoryAdd from "./components/FaqCategory/Add";
import FaqCategoryEdit from "./components/FaqCategory/Edit";

import FaqList from "./components/Faq/List";
import FaqAdd from "./components/Faq/Add";
import FaqEdit from "./components/Faq/Edit";
import FaqImport from "./components/Faq/ImportFaq";


import AiFeedList from "./components/AiFeed/List";
import AiImport from "./components/AiFeed/Import";


import DashboardManagement from "./components/DashboardManagement/List";
import DashboardAdd from "./components/DashboardManagement/Add";
import DashboardEdit from "./components/DashboardManagement/Edit";


import AdvertisementList from "./components/Advertisement/List";
import AdvertisementEdit from "./components/Advertisement/Edit";
import AdvertisementAdd from "./components/Advertisement/Add";

import AdsCategoryList from "./components/AdsCategory/List";
import AdsCategoryAdd from "./components/AdsCategory/Add";
import AdsCategoryEdit from "./components/AdsCategory/Edit";



import GuideList from "./components/Guide/List";
import GuideEdit from "./components/Guide/Edit";
import GuideAdd from "./components/Guide/Add";

import GuideCategoryList from "./components/GuideCategory/List";
import GuideCategoryAdd from "./components/GuideCategory/Add";
import GuideCategoryEdit from "./components/GuideCategory/Edit";
import GuideSubCategoryList from "./components/GuideSubCategory/List";
import GuideSubCategoryAdd from "./components/GuideSubCategory/Add";
import GuideSubCategoryEdit from "./components/GuideSubCategory/Edit";

import AbusiveWordList from "./components/AbusiveWord/List";
import AbusiveWordAdd from "./components/AbusiveWord/Add";
import AbusiveWordEdit from "./components/AbusiveWord/Edit";

import CHATList from "./components/ChatIcons/List";
import CHATEdit from "./components/ChatIcons/Edit";
import CHATAdd from "./components/ChatIcons/Add";

import Shortcuticon from "./components/Shortcuticon/List";
import ShortcuticonAdd from "./components/Shortcuticon/Add";
import ShortcuticonEdit from "./components/Shortcuticon/Edit";


import './common/css/custom.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route exact path="/profile" element={< Adminprofile />} />
      <Route path="/logout" element={< Logout />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/changepassword" element={<Changepassword />} />
      <Route path="/forget_password" component={Forgetpassword} />
      <Route path="/reset_password/:key" component={Resetpassword} />
     
      <Route path="/font-edit/:ID" element={<FontEdit />} />
      <Route path="/fonts" element={<Fontlist />} />
      <Route path="/font-add" element={<FontAdd />} />

      <Route path="/user" element={<UserList/>} />
      <Route path="/user-add" element={< UserAdd/>} />
      <Route path="/user-edit/:ID" element={<UserEdit/>} />
      <Route path="/user-view/:ID" element={<UserView/>} />
      <Route path="/contractor" element={<ContractorList/>} />
      <Route path="/contractor-add" element={<ContractorAdd/>} />
      <Route path="/contractor-edit/:ID" element={<ContractorEdit/>} />
      <Route path="/contractor-view/:ID" element={<ContractorView/>} />

      <Route path="/subcontractor" element={<SubcontractorList/>} />
      <Route path="/subcontractor-add" element={<SubcontractorAdd/>} />
      <Route path="/subcontractor-edit/:ID" element={<SubcontractorEdit/>} />
      <Route path="/subcontractor-view/:ID" element={<SubcontractorView/>} />

      <Route path="/project" element={<ProjectList/>} />
      <Route path="/project-view/:ID" element={<ProjectView/>} />

      <Route path="/job" element={<JobList/>} />
      <Route path="/job-view/:ID" element={<JobView/>} />

      <Route path="/companies" element={<CompaniesList/>} />
      <Route path="/companies-add" element={<CompaniesAdd/>} />
      <Route path="/companies-edit/:ID" element={<CompaniesEdit/>} />
      <Route path="/companies-view/:ID" element={<CompaniesView/>} />
      

      <Route path="/templates" element={<TemplateList />} />
      <Route path="/template/add" element={<TemplateAdd/>} />
      <Route path="/templates-edit/:ID" element={<TemplateEdit />} />
      <Route path="/dashboard" element={<DashboardList />} /> 
      
      <Route path="/faqcategory" element={<FaqCategoryList/>} />
      <Route path="/faqcategory-add" element={<FaqCategoryAdd/>} />
      <Route path="/faqcategory-edit/:ID" element={<FaqCategoryEdit/>} />  

      <Route path="/faq" element={<FaqList/>} />
      <Route path="/faq-add" element={<FaqAdd/>} />
      <Route path="/faq-edit/:ID" element={<FaqEdit/>} />
      <Route path="/faq-import" element={<FaqImport/>} />

            
      <Route path="/aifeed" element={<AiFeedList/>} />
      <Route path="/aifeed-import" element={<AiImport/>} />
      

        <Route path="/dashboardmanagement" element={<DashboardManagement/>} />
        <Route path="/dashboardmanagement-edit/:ID" element={<DashboardEdit/>} />
        {/* <Route path="/dashboardmanagement-add" component={<DashboardAdd/>} /> */}

      <Route path="/advertisement" element={<AdvertisementList/>} />
      <Route path="/advertisement-add" element={<AdvertisementAdd/>} />
      <Route path="/advertisement-edit/:ID" element={<AdvertisementEdit/>} />

      <Route path="/adscategory" element={<AdsCategoryList/>} />
      <Route path="/adscategory-add" element={<AdsCategoryAdd/>} />
      <Route path="/adscategory-edit/:ID" element={<AdsCategoryEdit/>} />
      

      <Route path="/guide" element={<GuideList/>} />
      <Route path="/guide-edit/:ID" element={<GuideEdit/>} />
      <Route path="/guide-add" element={<GuideAdd/>} />

      <Route path="/guidecategory" element={<GuideCategoryList/>} />
      <Route path="/guidecategory-add" element={<GuideCategoryAdd/>} />
      <Route path="/guidecategory-edit/:ID" element={<GuideCategoryEdit/>} /> 

      <Route path="/guidesubcategory" element={<GuideSubCategoryList/>} />
      <Route path="/guidesubcategory-add" element={<GuideSubCategoryAdd/>} />
      <Route path="/guidesubcategory-edit/:ID" element={<GuideSubCategoryEdit/>} />

      <Route path="/abusiveword-edit/:ID" element={<AbusiveWordEdit/>} />
      <Route path="/abusivewords" element={<AbusiveWordList/>} />
      <Route path="/abusiveword-add" element={<AbusiveWordAdd/>} />
    
      <Route path="/chat" element={<CHATList/>} />
      <Route path="/chat-edit/:ID" element={<CHATEdit/>} />
      <Route path="/chat-add" element={<CHATAdd/>} /> 

      <Route path="/shortcuticon/edit/:ID" element={<ShortcuticonEdit/>} />
      <Route path="/shortcuticon" element={<Shortcuticon/>} />
      <Route path="/shortcuticon-add" element={<ShortcuticonAdd/>} />
    
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
